module.exports = __webpack_public_path__ + "media/packs/landing_page/images/que_es-89de9938b6a91a78baefedcb524a508b.jpg";